module.exports = __webpack_public_path__ + "static/media/blonde-guy.7f81e97e.png";